import type { FaireProductEntity } from "../../entity_types/product";

export const p_4vjn8bbj: FaireProductEntity = {
  token: "p_4vjn8bbj",
  type: "product",
  name: "All-Natural Sea Salt - Roasted Garlic - 2 oz",
  brandToken: "b_4l4trvmb",
  brandName: "Salt Sisters",
  imageUrl:
    "https://cdn.faire.com/fastly/85998fef52c4391e8585b704de317fc90799f480f8787b740c7f5de51ffb0302.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8b780b2ddd06c6b9dd01c8fcea7287dc0fc8864d43c4cd10580e554e06f13653.jpeg",
    "https://cdn.faire.com/fastly/3205935a4c4801c63e5c50ec2c23a3a277cf1c4b983eb08778751c6c8457aa54.jpeg",
    "https://cdn.faire.com/fastly/5746103602824d47243fc42bafdc477cebda65bb6d6c6c53435229e35742f1d1.jpeg",
    "https://cdn.faire.com/fastly/5b256249b55e1e369acbdc6dd6801a87665356a2e92c2587cdbbeb35c9c94386.webp",
  ],
  priceDollars: 5.49,
  description:
    "This aromatic sea salt blend melds real roasted garlic with all-natural sea salt for a rich, savory flavor. The roasted garlic adds an enticing depth, making it an essential seasoning with a well-balanced texture that’s perfect for elevating a range of dishes.\n\nPerfect for finishing and topping, cooking, dry brining, or adding to rubs and marinades, this versatile salt enhances the savory flavor of everything from pretzels to marinades.\n\n* Herb Crusted Cod recipe on back.\n\nOur USA made, farm to table products contain no MSG, no preservatives and are non-GMO, making them a great idea for host / hostess gifts or as a way to elevate special events such as game day, family gatherings and holidays.",
  tags: [],
  msrpDollars: 11.07,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:57.654Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
